<div class="main">
  <mat-card appearance="filled">
    <mat-card-content class="content-holder">
        <div class="info-holder">
          <mat-icon>share</mat-icon>
          <div class="text-holder">
            <div>{{ selectedProject()?.ownerName}}.</div>
            <div>{{ selectedProject()?.projectName }}.</div>
          </div>
        </div>
        <h4>Scanna QR-koden för signering:</h4>
        <smt-qr-code
          cdkOverlayOrigin
          #qrCodeOrigin="cdkOverlayOrigin"
          class="qr-code"
          data="https://bildsamtycke.se"
        />

      <smt-tutorials
        [objectId]="qrCodeOrigin"
        tutorialId="qrCode"
        tutorialText="Be den eller de som ska signera att scanna QR-koden med sin mobilkamera!"
      />

        <h4>
          Länksignering:
        </h4>

        <button
          cdkOverlayOrigin
          #linkSignOrigin="cdkOverlayOrigin"
          (click)="linkCopiedSnackBar()"
          cdkCopyToClipboard="https://bildsamtycke.se"
          matButton="filled">
          <mat-icon>link</mat-icon>
          Kopiera länk
        </button>

      <smt-tutorials
        [objectId]="linkSignOrigin"
        tutorialId="linkSign"
        tutorialText="Behöver du skicka en länk till den som ska signera?"
      />

      <mat-divider/>
        <mat-expansion-panel>
          <mat-expansion-panel-header>Insamlade Bildsamtycke</mat-expansion-panel-header>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
          <div class="expansion-objects">260510 - 10:46: Frasse Fransson</div>
        </mat-expansion-panel>
    </mat-card-content>
  </mat-card>
</div>